/* PDP Mobile Fullscreen Gallery Viewer
   Tap image → fullscreen overlay with swipe, arrows, close, thumbnails
   Pinch-to-zoom + pan + double-tap zoom */
(function() {
  if (window.innerWidth >= 750) return;

  var overlay, mainSwiper, thumbSwiper, isOpen = false;

  /* ---- Pinch Zoom Engine ---- */
  function initPinchZoom(wrap, swiperInstance) {
    var img = wrap.querySelector('img');
    if (!img) return;

    var scale = 1, lastScale = 1;
    var posX = 0, posY = 0, lastPosX = 0, lastPosY = 0;
    var startDist = 0, startMidX = 0, startMidY = 0;
    var isPinching = false, isPanning = false;
    var panStartX = 0, panStartY = 0;
    var lastTap = 0;
    var maxScale = 4, minScale = 1;

    function getDistance(t1, t2) {
      var dx = t1.clientX - t2.clientX;
      var dy = t1.clientY - t2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function applyTransform() {
      img.style.transform = 'translate(' + posX + 'px, ' + posY + 'px) scale(' + scale + ')';
    }

    function clampPos() {
      if (scale <= 1) { posX = 0; posY = 0; return; }
      var rect = wrap.getBoundingClientRect();
      var imgW = img.naturalWidth || rect.width;
      var imgH = img.naturalHeight || rect.height;
      var dispW = rect.width;
      var dispH = rect.height;
      var maxX = Math.max(0, (dispW * scale - dispW) / 2);
      var maxY = Math.max(0, (dispH * scale - dispH) / 2);
      posX = Math.max(-maxX, Math.min(maxX, posX));
      posY = Math.max(-maxY, Math.min(maxY, posY));
    }

    function resetZoom() {
      scale = 1; lastScale = 1;
      posX = 0; posY = 0; lastPosX = 0; lastPosY = 0;
      img.style.transform = '';
      img.style.transition = '';
      if (swiperInstance) swiperInstance.allowTouchMove = true;
    }

    wrap.addEventListener('touchstart', function(e) {
      /* Double tap to zoom */
      if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lastTap < 300) {
          e.preventDefault();
          if (scale > 1) {
            img.style.transition = 'transform 0.3s ease';
            resetZoom();
            setTimeout(function() { img.style.transition = ''; }, 300);
          } else {
            scale = 2.5; lastScale = scale;
            var rect = wrap.getBoundingClientRect();
            var touch = e.touches[0];
            posX = (rect.width / 2 - (touch.clientX - rect.left)) * (scale - 1) / scale;
            posY = (rect.height / 2 - (touch.clientY - rect.top)) * (scale - 1) / scale;
            clampPos();
            img.style.transition = 'transform 0.3s ease';
            applyTransform();
            if (swiperInstance) swiperInstance.allowTouchMove = false;
            setTimeout(function() { img.style.transition = ''; }, 300);
          }
          lastTap = 0;
          return;
        }
        lastTap = now;

        /* Start pan if zoomed */
        if (scale > 1) {
          isPanning = true;
          panStartX = e.touches[0].clientX - posX;
          panStartY = e.touches[0].clientY - posY;
          e.preventDefault();
        }
      }

      /* Pinch start */
      if (e.touches.length === 2) {
        e.preventDefault();
        isPinching = true;
        isPanning = false;
        startDist = getDistance(e.touches[0], e.touches[1]);
        lastScale = scale;
        lastPosX = posX;
        lastPosY = posY;
        startMidX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        startMidY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        if (swiperInstance) swiperInstance.allowTouchMove = false;
        img.style.transition = '';
      }
    }, { passive: false });

    wrap.addEventListener('touchmove', function(e) {
      if (isPinching && e.touches.length === 2) {
        e.preventDefault();
        var dist = getDistance(e.touches[0], e.touches[1]);
        scale = Math.max(minScale, Math.min(maxScale, lastScale * (dist / startDist)));

        /* Zoom towards pinch center */
        var rect = wrap.getBoundingClientRect();
        var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        posX = lastPosX + (midX - startMidX);
        posY = lastPosY + (midY - startMidY);
        clampPos();
        applyTransform();
      } else if (isPanning && e.touches.length === 1 && scale > 1) {
        e.preventDefault();
        posX = e.touches[0].clientX - panStartX;
        posY = e.touches[0].clientY - panStartY;
        clampPos();
        applyTransform();
      }
    }, { passive: false });

    wrap.addEventListener('touchend', function(e) {
      if (isPinching && e.touches.length < 2) {
        isPinching = false;
        lastScale = scale;
        lastPosX = posX;
        lastPosY = posY;
        if (scale <= 1.05) {
          img.style.transition = 'transform 0.2s ease';
          resetZoom();
          setTimeout(function() { img.style.transition = ''; }, 200);
        } else if (swiperInstance) {
          swiperInstance.allowTouchMove = false;
        }
      }
      if (isPanning && e.touches.length === 0) {
        isPanning = false;
        lastPosX = posX;
        lastPosY = posY;
      }
    });

    return { reset: resetZoom };
  }

  function buildOverlay(slides, startIndex) {
    if (overlay) overlay.remove();

    var html = '<div class="pdp-lightbox">';
    html += '<button class="pdp-lightbox__close" aria-label="Close">&times;</button>';
    html += '<button class="pdp-lightbox__arrow pdp-lightbox__arrow--prev" aria-label="Previous">&#8249;</button>';
    html += '<button class="pdp-lightbox__arrow pdp-lightbox__arrow--next" aria-label="Next">&#8250;</button>';
    html += '<div class="pdp-lightbox__counter"><span class="pdp-lightbox__current">' + (startIndex + 1) + '</span> / ' + slides.length + '</div>';
    html += '<div class="swiper pdp-lightbox__main"><div class="swiper-wrapper">';
    slides.forEach(function(s) {
      html += '<div class="swiper-slide"><div class="pdp-lightbox__img-wrap"><img src="' + s.fullSrc + '" alt="" draggable="false"></div></div>';
    });
    html += '</div></div>';
    html += '<div class="swiper pdp-lightbox__thumbs"><div class="swiper-wrapper">';
    slides.forEach(function(s) {
      html += '<div class="swiper-slide"><img src="' + s.thumbSrc + '" alt="" draggable="false"></div>';
    });
    html += '</div></div>';
    html += '</div>';

    var div = document.createElement('div');
    div.innerHTML = html;
    overlay = div.firstElementChild;
    document.body.appendChild(overlay);

    document.body.style.overflow = 'hidden';

    mainSwiper = new Swiper('.pdp-lightbox__main', {
      initialSlide: startIndex,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.pdp-lightbox__arrow--next',
        prevEl: '.pdp-lightbox__arrow--prev'
      }
    });

    thumbSwiper = new Swiper('.pdp-lightbox__thumbs', {
      initialSlide: startIndex,
      slidesPerView: 'auto',
      spaceBetween: 6,
      slideToClickedSlide: true,
      centeredSlides: true
    });

    /* Init pinch zoom on each slide */
    var zoomInstances = [];
    overlay.querySelectorAll('.pdp-lightbox__img-wrap').forEach(function(wrap) {
      zoomInstances.push(initPinchZoom(wrap, mainSwiper));
    });

    /* Reset zoom on slide change */
    mainSwiper.on('slideChange', function() {
      var idx = mainSwiper.activeIndex;
      thumbSwiper.slideTo(idx);
      updateActiveThumb(idx);
      updateCounter(idx);
      zoomInstances.forEach(function(z) { z.reset(); });
      mainSwiper.allowTouchMove = true;
    });

    var thumbSlides = overlay.querySelectorAll('.pdp-lightbox__thumbs .swiper-slide');
    thumbSlides.forEach(function(ts, i) {
      ts.addEventListener('click', function() {
        mainSwiper.slideTo(i);
        updateActiveThumb(i);
      });
    });

    updateActiveThumb(startIndex);

    overlay.querySelector('.pdp-lightbox__close').addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeOverlay();
    });

    isOpen = true;
  }

  function updateActiveThumb(idx) {
    if (!overlay) return;
    var thumbs = overlay.querySelectorAll('.pdp-lightbox__thumbs .swiper-slide');
    thumbs.forEach(function(t, i) {
      t.classList.toggle('is-active', i === idx);
    });
  }

  function updateCounter(idx) {
    if (!overlay) return;
    var el = overlay.querySelector('.pdp-lightbox__current');
    if (el) el.textContent = idx + 1;
  }

  function closeOverlay() {
    if (!overlay) return;
    if (mainSwiper) { mainSwiper.destroy(true, true); mainSwiper = null; }
    if (thumbSwiper) { thumbSwiper.destroy(true, true); thumbSwiper = null; }
    overlay.remove();
    overlay = null;
    document.body.style.overflow = '';
    isOpen = false;
  }

  document.addEventListener('click', function(e) {
    if (window.innerWidth >= 750) return;
    if (isOpen) return;

    var target = e.target.closest('.product__gallery-zoom-target');
    if (!target) return;

    var allTargets = [];
    document.querySelectorAll('.product__gallery-zoom-target[data-full-src]').forEach(function(t) {
      if (t.closest('.swiper-slide-duplicate')) return;
      if (t.offsetParent !== null || t.offsetWidth > 0) allTargets.push(t);
    });
    if (!allTargets.length) {
      document.querySelectorAll('.product__gallery-zoom-target[data-full-src]').forEach(function(t) {
        if (!t.closest('.swiper-slide-duplicate')) allTargets.push(t);
      });
    }
    if (!allTargets.length) return;

    var slides = [];
    var startIndex = 0;
    var seenSrcs = {};
    var targetSrc = target.getAttribute('data-full-src');
    allTargets.forEach(function(t) {
      var src = t.getAttribute('data-full-src');
      if (seenSrcs[src]) return;
      seenSrcs[src] = true;
      var idx = slides.length;
      slides.push({
        fullSrc: src,
        thumbSrc: t.getAttribute('data-thumb-src') || src
      });
      if (t === target || src === targetSrc) startIndex = idx;
    });

    buildOverlay(slides, startIndex);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) closeOverlay();
  });
})();
